<template>
    <router-view v-slot="{ Component, route }">
        <keep-alive :include="tagViews"><component :is="Component" :key="route.path" /></keep-alive>
    </router-view>
</template>
<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
    setup() {
        let store = useStore();
        let tagViews = computed(() => store.state.common.tagViews);

        return {
            tagViews
        };
    }
};
</script>
